const URL_REQUERIMIENTO = 'informatica/requerimientos'
const URL_MOVIMIENTOS = 'informatica/requerimientos/{id}/movimiento'
const URL_TAREAS = 'informatica/requerimientos/{id}/tareas'
const URL_CAMBIOS = 'informatica/requerimientos/'

export {
    URL_REQUERIMIENTO,
    URL_MOVIMIENTOS,
    URL_CAMBIOS,
    URL_TAREAS
}
